export default {
  title: 'Multi-lingual',
  weblateSuperAdminPanel: 'Weblate Super Admin Panel',
  weblateSuperAdminPanelDescription: 'Create and manage users and their groups',
  weblateTranslations: 'Weblate Translations',
  weblateTranslationsDescription: 'Manage translations',
  retrieveBasicTranslations: 'Retrieve basic translations',
};
